const _excluded = ["refs", "middlewareData", "floatingStyles", "update"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useMemo } from 'react';
import { useFloating, autoUpdate, arrow, offset, flip, shift, hide } from '@floating-ui/react-dom';
export default function usePopper(_ref) {
  var _middlewareData$arrow, _middlewareData$arrow2;
  let {
    placement: initialPlacement = 'bottom',
    offset: offsetProp,
    fixed = false,
    targetElement,
    overlayElement,
    arrowElement,
    shiftArgs,
    flipArgs,
    hideArgs,
    show,
    isOverlayConditionallyRendered = true
  } = _ref;
  const middleware = useMemo(() => {
    const toReturn = [];

    /**
     * Do not add middleware if overlay is not shown and rendered.
     * This causes unnecessary calculation and rerendering
     */

    if (isOverlayConditionallyRendered || show) {
      if (offsetProp) {
        // TODO this awkwardness is to support our current API, if we break we can adopt the new options object
        const [crossAxis, mainAxis] = offsetProp;
        toReturn.push(offset({
          mainAxis,
          crossAxis
        }));
      }
      toReturn.push(flip(flipArgs));
      toReturn.push(shift(shiftArgs));
      if (arrowElement) {
        toReturn.push(arrow({
          element: arrowElement
        }));
      }
      toReturn.push(hide(hideArgs));
    }
    return toReturn;
  }, [shiftArgs, hideArgs, isOverlayConditionallyRendered, show, arrowElement, offsetProp, flipArgs]);
  const _useFloating = useFloating({
      placement: initialPlacement,
      whileElementsMounted: autoUpdate,
      elements: {
        reference: targetElement,
        floating: overlayElement
      },
      open: show,
      middleware,
      strategy: fixed ? 'fixed' : 'absolute'
    }),
    {
      refs,
      middlewareData,
      floatingStyles,
      update
    } = _useFloating,
    rest = _objectWithoutProperties(_useFloating, _excluded);
  if (hideArgs !== null && hideArgs !== void 0 && hideArgs.strategy && overlayElement) {
    var _middlewareData$hide;
    overlayElement.style.visibility = (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide[hideArgs.strategy] ? 'hidden' : 'visible';
  }
  const arrowStyles = {
    transform: `translate(${Math.round(((_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x) || 0)}px,${Math.round(((_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y) || 0)}px)`
  };
  return _objectSpread({
    // floatingStyles is an object, but is typed as CSSProperties, which includes `string` so we cast it to keep our current API
    // We could remove this cast in a breaking change
    popoverStyles: floatingStyles,
    arrowStyles,
    refs
  }, rest);
}
//# sourceMappingURL=usePopper.js.map